
export const ACTION_TYPE = {
    FETCH_GLOBAL_DATA : 'FETCH_GLOBAL_DATA',
    FETCH_ALL_COUNTRY_SUMMARY: 'FETCH_ALL_COUNTRY_SUMMARY',
    FETCH_INDIA_STATE_SUMMARY: 'FETCH_INDIA_STATE_SUMMARY',
    FETCH_INDIA_STATE_DETAILS: 'FETCH_INDIA_STATE_DETAILS',
    FETCH_STATE_ZONE_DETAILS: 'FETCH_STATE_ZONE_DETAILS',
}